/**
 * Homepage section mapping — field accessors (API camelCase / PascalCase).
 * Keeps rendering logic out of components for future AI / personalization hooks.
 */

export const getSectionId = (section) => section?.id ?? section?.Id;

export const getSectionName = (section) =>
  section?.sectionName || section?.SectionName || "Untitled Section";

export const getSectionLayout = (section) =>
  section?.sectionLayout || section?.SectionLayout || "-";

export const isSectionFeatured = (section) => {
  const value = section?.isFeatured ?? section?.IsFeatured;
  return value === true || value === "true" || value === 1;
};

export const getMappingItemId = (item) => item?.id ?? item?.Id;

export const getMappedContentId = (item) =>
  item?.contentId ??
  item?.ContentId ??
  item?.content?.id ??
  item?.content?.Id;

export const getMappingDisplayOrder = (item) =>
  item?.displayOrder ?? item?.DisplayOrder ?? 0;

export const getContentId = (content) => content?.id ?? content?.Id;

export const getContentTitle = (content) =>
  content?.title || content?.Title || "-";

export const getCategoryName = (item) =>
  item?.categoryName ||
  item?.CategoryName ||
  item?.contentCategoryName ||
  item?.ContentCategoryName ||
  "-";

export const getTopicName = (item) =>
  item?.topicName ||
  item?.TopicName ||
  item?.contentTopicName ||
  item?.ContentTopicName ||
  "-";

export const getImageUrl = (item) =>
  item?.contentImageUrl ||
  item?.ContentImageUrl ||
  item?.thumbnailUrl ||
  item?.ThumbnailUrl ||
  "";

export const getPublishedOn = (item) => {
  const raw = item?.publishedOn || item?.PublishedOn;
  if (!raw) return "-";
  const date = new Date(raw);
  return Number.isNaN(date.getTime())
    ? String(raw)
    : date.toLocaleString();
};

export const isTruthyFlag = (item, camelKey, pascalKey) => {
  const value = item?.[camelKey] ?? item?.[pascalKey];
  return value === true || value === "true" || value === 1;
};

export const normalizeMappedItemsList = (data) => {
  const list = Array.isArray(data) ? data : [];
  return [...list].sort(
    (a, b) => getMappingDisplayOrder(a) - getMappingDisplayOrder(b)
  );
};

export const buildReorderPayload = (items) =>
  items.map((item, index) => ({
    id: getMappingItemId(item),
    displayOrder: index + 1,
  }));
